import { registerGrpcClient } from 'libs/grpckit/src';
import { Module } from 'libs/uikit/ioc';
import { EmailsClient } from '../api/Clients';

export interface NotificationsModuleConfig {
  notificationsApiUrl: string;
}

export const notificationsModule = (config: NotificationsModuleConfig) => {
  return new Module({
    providers: [registerGrpcClient(EmailsClient, config.notificationsApiUrl)],
  });
};
